document.addEventListener("DOMContentLoaded", function () {
    const checkbox = document.getElementById("collect_from_store");
    const deliveryFields = document.getElementById("delivery-fields");
    
    // Do nothing if checkout elements are not on this page
    if (!checkbox || !deliveryFields) {
        console.log("Checkout elements not found.");
    } else {
        const inputs = deliveryFields.querySelectorAll(
            "input, textarea, select"
        );
    
        checkbox.addEventListener("change", function () {
            if (this.checked) {
                deliveryFields.style.display = "none";
    
                // Clear all delivery fields
                inputs.forEach(function (input) {
                    if (
                        input.type === "checkbox" ||
                        input.type === "radio"
                    ) {
                        input.checked = false;
                    } else {
                        input.value = "";
                    }
                });
            } else {
                deliveryFields.style.display = "block";
            }
        });
    }
    
    });
    